import { render, staticRenderFns } from "./NewConsolidation.vue?vue&type=template&id=06d50ae7"
import script from "./NewConsolidation.vue?vue&type=script&lang=js"
export * from "./NewConsolidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports